import React from "react";

export const Testimonials = (props) => {
  const cases = props.data || [];
  const onOpenCase = props.onOpenCase;

  return (
    <div id="testimonials">
      <div className="container">
        <div className="section-title text-center">
          <h2>Customer Cases</h2>
          <p>
            Real partnerships across game R&amp;D, intelligent documents, AI healthcare and overseas globalization — all powered by GOLDLY AI infrastructure.
          </p>
        </div>
        <div className="cases-grid">
          {cases.map((d, i) => (
            <button
              key={`${d.name}-${i}`}
              type="button"
              className={`case-card ribbon-${d.ribbon || "indigo"}`}
              onClick={() => onOpenCase && onOpenCase(d.slug)}
              aria-label={`Open case: ${d.name}`}
            >
              <div className="case-ribbon" />
              <div className="case-head">
                <div
                  className={`case-monogram${d.logo ? " has-logo" : ""}`}
                  aria-hidden="true"
                >
                  {d.logo ? (
                    <img
                      src={d.logo}
                      alt={`${d.name} logo`}
                      className="case-monogram-img"
                    />
                  ) : (
                    d.code
                  )}
                </div>
                <div className="case-head-text">
                  <div className="case-name">{d.name}</div>
                  <div className="case-industry">
                    <i className={d.icon || "fa fa-briefcase"} />{" "}
                    {d.industry}
                  </div>
                </div>
                {d.date && <div className="case-date">{d.date}</div>}
              </div>
              <p className="case-summary">{d.summary}</p>
              {Array.isArray(d.metrics) && d.metrics.length > 0 && (
                <ul className="case-metrics">
                  {d.metrics.map((m, idx) => (
                    <li key={idx} className="case-metric">{m}</li>
                  ))}
                </ul>
              )}
              <div className="case-foot">
                <div className="case-products">
                  {Array.isArray(d.products) &&
                    d.products.slice(0, 3).map((p, idx) => (
                      <span key={idx} className="case-chip">
                        {p}
                      </span>
                    ))}
                </div>
                <span className="case-readmore">
                  Read case <i className="fa fa-arrow-right" />
                </span>
              </div>
            </button>
          ))}
        </div>
        <p className="cases-disclaimer">
          Customer names referenced with permission from publicly announced partnerships.
        </p>
      </div>
    </div>
  );
};
